import { render, staticRenderFns } from "./BindAdvertisementForm.vue?vue&type=template&id=175559f8&scoped=true"
import script from "./BindAdvertisementForm.vue?vue&type=script&lang=js"
export * from "./BindAdvertisementForm.vue?vue&type=script&lang=js"
import style0 from "./BindAdvertisementForm.vue?vue&type=style&index=0&id=175559f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175559f8",
  null
  
)

export default component.exports